const size = 20;

/**
 * Ícone de pessoa/usuário para o header.
 * Usado dentro do círculo amarelo do AppLayout; o filtro deixa o ícone branco.
 * SVG inline para não depender de /assets/shared/.
 */
export function HeaderIconPerson() {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="currentColor"
      style={{ display: 'block', objectFit: 'contain' }}
      aria-hidden
    >
      <path d="M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z" />
    </svg>
  );
}
